/* globals Raven */

import React from "react";
import { withRouter } from "react-router";

import * as R from "ramda";
import { css } from "glamor";
import { Alert, Button } from "antd";

const styles = {
    wrapper: css({
        margin: "3rem 50px",
    }),
};

const getCurrentLocationKey = R.pathOr("", ["location", "key"]);

class ErrorBoundary extends React.Component {
    state = {
        error: null,
        reported: false,
        currentLocationKey: "",
    };

    hasRaven = typeof Raven !== "undefined";

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            currentLocationKey: getCurrentLocationKey(this.props),
        });

        if (this.hasRaven) {
            Raven.captureException(error, { extra: errorInfo });
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (state.currentLocationKey !== getCurrentLocationKey(props)) {
            return { error: null };
        }

        return { ...state };
    }

    handleReport = e => {
        e.preventDefault();

        if (Raven.lastEventId()) {
            Raven.showReportDialog();
        }

        this.setState({ reported: true });
    };

    render() {
        let report = null;

        if (this.hasRaven && !this.state.reported) {
            report = (
                <React.Fragment>
                    You can also{" "}
                    <Button
                        size="small"
                        onClick={this.handleReport}
                        type="primary"
                    >
                        tell us more
                    </Button>{" "}
                    about the problem.
                </React.Fragment>
            );
        }

        if (this.state.error) {
            return (
                <div {...styles.wrapper}>
                    <Alert
                        message="We're sorry - something's gone wrong."
                        description={
                            <p>
                                Our technical team has been notified about it.
                                <br />
                                Meanwhile, please try again as the error may be
                                intermittent.
                                {report}
                            </p>
                        }
                        type="error"
                        showIcon
                    />
                </div>
            );
        }

        return this.props.children;
    }
}

export default withRouter(ErrorBoundary);
